import { AuthenticationStore } from "@istari-frontend/auth";
import { IstariClient } from "@istari/istari-client";

import { invokeWithCurrentToken, refreshExpiredAccessToken } from "./client-invocation";
import { identityClientOptions } from "./identity-client-options";
import { resolveRegistryTarget } from "./registry-target";

type IdentityClient = IstariClient["identity"];

// The identity accessor exists only on a gateway client opted into v2; it throws otherwise.
const getIdentityClient = (): IdentityClient => {
  const AS = AuthenticationStore();
  const registryAuthToken = AS.getAccessToken() || "";
  const target = resolveRegistryTarget();
  const client =
    target.kind === "gateway"
      ? new IstariClient({ digitalApiUrl: target.digitalApiUrl, registryAuthToken, ...identityClientOptions() })
      : new IstariClient(target.registryUrl, registryAuthToken);
  return client.identity;
};

const identityClient = new Proxy({} as IdentityClient, {
  get(_target, prop) {
    const client = getIdentityClient();
    const value = client[prop as keyof IdentityClient];

    if (typeof value === "function") {
      return async (...args: unknown[]) => {
        await refreshExpiredAccessToken();
        return await invokeWithCurrentToken(getIdentityClient, prop as keyof IdentityClient, args);
      };
    }

    return value;
  },
});

export default identityClient;
